import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  PaymentStatusActions,
  PaymentStatusActionTypes,
} from '../actions/paymentStatus';

export interface PaymentStatusModel {
  unit_id: number;
  owner_id: number;
  status: string;
  stripe_customer_id: number;
  trial_end: string;
}

export const initialPaymentStatus: PaymentStatusModel = {
  unit_id: null,
  owner_id: null,
  status: null,
  stripe_customer_id: null,
  trial_end: null,
};

export interface PaymentStatusState extends EntityState<PaymentStatusModel> {}

export const adapter: EntityAdapter<PaymentStatusModel> = createEntityAdapter<
  PaymentStatusModel
>();

export function paymentStatusReducer(
  state = initialPaymentStatus,
  action: PaymentStatusActions
): PaymentStatusModel {
  switch (action.type) {
    case PaymentStatusActionTypes.paymentStatusLoaded:
      return action.payload.paymentStatus;

    case PaymentStatusActionTypes.paymentStatusLoadFailed:
      return { ...initialPaymentStatus, status: 'error' };

    default: {
      return state;
    }
  }
}

export const {
  selectAll,
  selectIds,
  selectEntities,
  selectTotal,
} = adapter.getSelectors();
